export default __webpack_public_path__ + "static/media/ico.cf712373.obj";